<script>
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faHospital } from '@fortawesome/pro-light-svg-icons';
  import { onMount } from 'svelte';
  import { get } from 'svelte/store';
  import WelcomeDetails from '$lib/WelcomeDetails.svelte';
  import { user, isAuthenticated, setSession } from '$stores/sessionStore';
  import { page } from '$stores/pageStore';
  import { landAssignedUser } from '$lib/assignmentLanding';
  import { navigate as goto } from 'svelte-routing';

  // Send the user to their natural landing page based on assignments.
  // Parity with legacy: admin (no studies) -> /studies, study user -> /sites,
  // site user -> /persons. Without this, post-login lands on /dashboard which
  // breaks parity with legacy where landing on /studies was the norm.
  //
  // SPTL-486 (round 2): decouple the landing route from the study/site lookup
  // succeeding. Site users MUST land on /persons even if the pre-fetch of
  // selectedStudy/selectedSite errors — otherwise they get bounced to /sites
  // (which they have no permission to browse) or /studies (empty grid).
  // The pre-fetch is now a best-effort optimisation, not a gate.
  async function landingFor(userData) {
    await landAssignedUser(userData);
  }

  onMount(async () => {
    const url = $page.url;
    const userDataParam = url.searchParams.get('userData');

    if (userDataParam) {
      try {
        const userData = JSON.parse(decodeURIComponent(userDataParam));
        setSession(userData);

        // Strip userData from URL to avoid exposing sensitive data on refresh.
        const cleanUrl = new URL(url.href);
        cleanUrl.searchParams.delete('userData');
        window.history.replaceState({}, document.title, cleanUrl.pathname);

        await landingFor(userData);
        return;
      } catch (error) {
        console.error('Error processing user data from URL:', error);
        goto('/login?error=invalid_user_data');
        return;
      }
    }

    const authenticated = get(isAuthenticated);
    if (authenticated) {
      await landingFor(get(user));
    } else {
      goto('/login');
    }
  });
</script>

<WelcomeDetails />


